var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallSpecialistWonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36612 17.7411C8.85427 17.253 9.64573 17.253 10.1339 17.7411L15.2411 22.8483C15.7293 23.3365 15.7293 24.128 15.2411 24.6161C14.753 25.1043 13.9615 25.1043 13.4733 24.6161L8.36612 19.5089C7.87796 19.0207 7.87796 18.2293 8.36612 17.7411Z",
    fill: "#00CFB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4733 24.6161C12.9852 24.128 12.9852 23.3365 13.4733 22.8483L25.4556 10.8661C25.9437 10.378 26.7352 10.378 27.2233 10.8661C27.7115 11.3543 27.7115 12.1457 27.2233 12.6339L15.2411 24.6161C14.753 25.1043 13.9615 25.1043 13.4733 24.6161Z",
    fill: "#00CFB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM18 0.5C27.665 0.500001 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.499999 27.665 0.5 18C0.500001 8.33502 8.33502 0.499999 18 0.5Z",
    fill: "#00CFB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSpecialistWonIcon);
export default __webpack_public_path__ + "static/media/call-specialist-won-icon.56f0bdb8425a0bcb7e36675c1cd88fd5.svg";
export { ForwardRef as ReactComponent };